const kebabCaseCode = `import { kebabCase } from 'cristatus';

const kebabCaseString = kebabCase("helloWorld"); //hello world
`;

export default kebabCaseCode;
